import React, { useContext, useState } from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { PageContext } from "../../Context/PageContext";

export default function TextComponent({ id, text, icon }) {
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const { openQuestion } = useContext(PageContext);
  const { attributes, listeners, setNodeRef, transform, transition } =
    useDraggable({
      id: id,
      data: {
        type: "text",
        text,
      },
    });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  const handleDragOver = () => {
    setIsDraggingOver(true);
  };

  const handleDragLeave = () => {
    setIsDraggingOver(false);
  };
  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="border border-[#d3dce5] rounded-[1.8rem] flex justify-start min-h-[2.8rem] items-center pl-5 gap-2 bg-[#fff]"
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
    >
      {icon}
      {text}
      {isDraggingOver && (
        <div className="absolute bg-blue-500 text-white px-2 py-1 rounded-md">
          Drop here
        </div>
      )}
    </div>
  );
}
